import { h, Fragment } from 'preact';
import { useEffect, useRef, useState } from "preact/hooks";
import { useDebounce } from '../../utils/useDebounce';
import { updateMediaDetails, updateAttachmentDetails } from '../../api/updateMediaDetails';
import { vpCloseButton, vpDetailsContainer, vpDetailsModal } from '../VideoDetailsModal/VideoDetailsModal.css';
import Info from "../../../icons/info.svg";
import { extractThumbnailPath } from "../../utils";
import { vpFormTDStyles, vpInputStyle, vpLabelStyle, vpDialogStyles, vpDialogHeader, vpBannerStyle, vpErrorBar } from "./Forms.css";
function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        document.execCommand('copy');
    }
    catch (err) {
        console.error('Could not copy text', err);
    }
    document.body.removeChild(textArea);
}
function copyToClipboard(text) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }
    navigator.clipboard.writeText(text).then(function () {
        return;
    }, function (err) {
        console.error('Could not copy text: ', err);
    });
}
var MediaDetailsForm = function (_a) {
    var item = _a.item, isVideo = _a.isVideo, onClose = _a.onClose, _b = _a.isPreview, isPreview = _b === void 0 ? false : _b, orgId = _a.orgId;
    var id = item.id, title = item.title, description = item.description, thumbnail = item.thumbnail;
    var transcript = (item === null || item === void 0 ? void 0 : item.transcription) || {};
    var _c = useState(title), mediaTitle = _c[0], setTitle = _c[1];
    var _d = useState(description), mediaDescription = _d[0], setDescription = _d[1];
    var _e = useState(""), error = _e[0], setError = _e[1];
    var currentValues = useRef({ title: mediaTitle, description: mediaDescription });
    var handleSubmit = function (values) {
        var title = values.title, description = values.description;
        var data = {
            title: title || ' ',
            description: description || ' ',
            thumbnailUrl: extractThumbnailPath(thumbnail),
        };
        if (isVideo) {
            {
                isPreview && id && updateMediaDetails({ data: data, mediaId: id, enabled: isPreview, setError: setError, orgId: orgId });
            }
            ;
        }
        else {
            {
                isPreview && id && updateAttachmentDetails({ data: data, attachmentId: id, enabled: isPreview, setError: setError, orgId: orgId });
            }
            ;
        }
    };
    var debouncedHandleSubmit = useDebounce(function () { return handleSubmit(currentValues.current); }, 1000);
    useEffect(function () {
        currentValues.current = { title: mediaTitle, description: mediaDescription };
        debouncedHandleSubmit();
    }, [mediaTitle, mediaDescription]);
    var handleCopy = function (e) {
        e.stopPropagation();
        e.preventDefault();
        copyToClipboard((transcript === null || transcript === void 0 ? void 0 : transcript.content) || "");
    };
    return (h("div", { "data-testid": "details-modal-backdrop", className: vpDetailsModal },
        h("div", { className: vpDetailsContainer + " " + vpDialogStyles },
            h("div", { className: vpDialogHeader },
                h("label", { className: vpLabelStyle, style: "margin: 0;" }, "Edit Content Details"),
                h("span", { onClick: function () { return onClose && onClose(); }, className: vpCloseButton }, "\u00D7")),
            h("form", { onSubmit: handleSubmit, className: vpFormTDStyles },
                h("span", { className: vpBannerStyle },
                    h(Info, null),
                    " When you're done, close this window and hit the Refresh Preview button to save your changes"),
                error && h("span", { className: vpErrorBar }, error),
                h("label", { className: vpLabelStyle }, "Title:"),
                h("input", { className: vpInputStyle, type: "text", value: mediaTitle, onChange: function (event) { return setTitle(event.target.value); } }),
                h("label", { className: vpLabelStyle }, "Description:"),
                h("textarea", { rows: 4, className: vpInputStyle, type: "text", value: mediaDescription, onChange: function (event) { return setDescription(event.target.value); } }),
                isVideo &&
                    h(Fragment, null,
                        h("label", { className: vpLabelStyle }, "Transcript: "),
                        h("textarea", { rows: (transcript === null || transcript === void 0 ? void 0 : transcript.content) ? 4 : 1, className: vpInputStyle, type: "text", value: (transcript === null || transcript === void 0 ? void 0 : transcript.content) || "No Transcript Available. Navigate to Media Page for Transcription Status", disabled: true }))))));
};
export default MediaDetailsForm;
